import { TableCell } from '@mui/material';
import React from 'react';

interface Props {
  firstValue: string;
  secondValue: string;
}

import styles from './DuplicateCell.module.scss';

export const DuplicateCell: React.FC<Props> = (props) => {
  const { firstValue, secondValue } = props;
  return (
    <TableCell>
      <div
        data-duplicate={firstValue.trim() === secondValue.trim()}
        className={styles.container}
      >
        <div className={styles.firstRow}>{firstValue}</div>
        <div className={styles.row}>{secondValue}</div>
      </div>
    </TableCell>
  );
};
